export const SALE_GUIDE_LIST = [
  {
    step: 1,
    title: 'Подготовьте дом и квартиру к продаже',
    slider: [
      {
        image: '5184a6e62670c23b35be751d062216d5.png',
        title: 'Как обустроить и украсить квартиру, чтобы продать ее быстрее?',
        notice: '6 мин. чтения',
        link: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch-2-houm-stejdzhing-287784/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '35666ca6b17f83be986fcd252564ede6.png',
        title: 'Список документов, которые стоит собрать еще до продажи квартиры',
        notice: '6 мин. чтения',
        link: 'https://www.cian.ru/stati-spisok-dokumentov-kotorye-stoit-sobrat-esche-do-prodazhi-kvartiry-327328/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'cbd59636e00439818351884eb6bd159a.png',
        title: 'Семь простых правил, чтобы удачно сфотографировать квартиру',
        notice: '10 мин. чтения',
        link: 'https://www.cian.ru/stati-sem-prostyh-pravil-chtoby-udachno-sfotografirovat-kvartiru-317104/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'b38b0b91ba3b59f293a2a3b81b2e3552.png',
        title: 'Как правильно оценить свою квартиру',
        notice: '11 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-pravilno-otsenit-svoju-kvartiru-327064/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '567c2338894c9dd0061ad127cfd45ac5.png',
        title: 'Как быстро продать квартиру: советы риелторов и юристов',
        notice: '8 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-bystro-prodat-kvartiru-sovety-rieltorov-i-juristov-327840/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'a3436fd1ded11b6e3563fb0cc4a91759.png',
        title: 'Как выбрать идеальный момент для продажи квартиры',
        notice: '7 мин. чтения',
        link: 'https://www.cian.ru/stati-vybiraem-idealnyj-moment-dlja-prodazhi-kvartiry-327321/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '213b14999203a9862b59b97d8081fd21.png',
        title: 'Продажа квартиры: составьте план, чтобы ничего не упустить',
        notice: '9 мин. чтения',
        link: 'https://www.cian.ru/stati-prodazha-kvartiry-sostavte-plan-chtoby-nichego-ne-upustit-327350/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 2,
    title: 'Создайте эффективное объявление',
    slider: [
      {
        image: '28a7122d8620ec70777dbf22e62a15a5.png',
        title: 'Как написать удачное объявление о продаже? Разбираем по пунктам',
        notice: '8 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-napisat-udachnoe-objavlenie-o-prodazhe-razbiraem-po-punktam-327320/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '1682a18d96fc52d709f231b1667492be.png',
        title:
          'Как создать привлекательную страницу объявления? На что обратить внимание, чтобы привлечь больше внимания к объявлению на Циан?',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-privlech-bolshe-vnimanija-k-svoemu-objavleniju-na-tsian-333459/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '666976e400c9dba371158f9f341bfed8.png',
        title: 'Пошаговая инструкция, как разместить объявление на Циан.',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-poshagovaja-instruktsija-kak-razmestit-objavlenie-na-tsian-332829/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '67cc9f56176ffaef5a3e0532f88088a5.png',
        title: 'Восемь лайфхаков, как продать квартиру максимально выгодно',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-vosem-lajfhakov-kak-prodat-kvartiru-maksimalno-vygodno-327316/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 3,
    title: 'Принимайте звонки и общайтесь с потенциальными покупателями в чатах',
    slider: [
      {
        image: 'f3e6054753587b75d463ec18937be0b4.png',
        title: 'Звонки по объявлению — как правильно разговаривать с покупателем?',
        notice: '7 мин. чтения',
        link: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch10-zvonki-po-objavleniju-kak-razgovarivat-287947/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'a6041e9f18de8e619da4319083f291a3.png',
        title: 'Как общаться в чатах с покупателями?',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-obschatsja-s-pokupateljami-v-chatah-chtoby-bystree-prodat-kvartiru-333097/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '7437c89ef49e7e38af50a958e1381a63.png',
        title: 'Как управлять ценой в объявлении (чтобы ускорить продажу, но и не продешевить)?',
        notice: '7 мин. чтения',
        link: 'https://www.cian.ru/stati-upravljaem-tsenoj-v-objavlenii-kak-prodat-svoj-obekt-bystro-i-ne-prodeshevit-333279/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'e9469b6af68343142ab423374a1cda32.png',
        title: 'По объявлению о продаже мало звонков? Рассказываем, что делать',
        notice: '7 мин. чтения',
        link: 'https://www.cian.ru/stati-po-objavleniju-o-prodazhe-nikto-ne-zvonit-rasskazyvaem-chto-delat-327312/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 4,
    title: 'Как проводить показ квартиры/дома',
    slider: [
      {
        image: 'a1a016c6020a0d29ec88b0ec3e9d057c.png',
        title: 'Без права на повтор: как правильно показывать квартиру',
        notice: '10 мин. чтения',
        link: 'https://www.cian.ru/stati-bez-prava-na-povtor-kak-pravilno-pokazyvat-kvartiru-327317/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'a96600cc6071a6454028873dfcb04d6d.png',
        title: 'Аванс или задаток, что выбрать?',
        notice: '3 мин. чтения',
        link: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch12-avans-ili-zadatok-chto-vybrat-288010/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '09bd228c5581c7347d4f803537a3b0e7.png',
        title: 'С продажей квартиры что-то пошло не так. Что делать?',
        notice: '7 мин. чтения',
        link: 'https://www.cian.ru/stati-s-prodazhej-kvartiry-chto-to-poshlo-ne-tak-chto-delat-327315/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 5,
    title: 'Как заключить договор',
    slider: [
      {
        image: '9106dbc5114909083adcb2fc9fd3c0d6.png',
        title: 'Как проходит сделка по продаже квартиры: пошаговая инструкция',
        notice: '6 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-prohodit-sdelka-po-prodazhe-kvartiry-poshagovaja-instruktsija-327334/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '6e52ce25b133ef07c421cc38d31ad74f.png',
        title: 'Чек-лист для документов, которые потребуются при продаже квартиры',
        notice: '9 мин. чтения',
        link: 'https://www.cian.ru/stati-chek-list-dlja-dokumentov-kotorye-potrebujutsja-pri-prodazhe-kvartiry-327333/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'd1b082bc8bd664b474ff13a649ed59a8.png',
        title: 'Как составить договор купли-продажи, чтобы ничего не забыть? Инструкция',
        notice: '8 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-sostavit-dogovor-kupli-prodazhi-chtoby-nichego-ne-zabyt-instruktsija-314940/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'b84c5c6ce12eb28baf854fbdadc6bd49.png',
        title: 'Предварительный договор купли-продажи недвижимости: зачем и когда он нужен',
        notice: '15 мин. чтения',
        link: 'https://www.cian.ru/stati-predvaritelnyj-dogovor-kupli-prodazhi-nedvizhimosti-zachem-i-kogda-on-nuzhen-327570/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'c247dd05155c31867c8141fdcbf505cd.png',
        title: 'Как правильно передать квартиру покупателю',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-pravilno-peredat-kvartiru-pokupatelju-327325/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 6,
    title: 'Разбираемся в тонкостях',
    slider: [
      {
        image: 'f7fc4d712b5d056f4b4ce78d3a413a35.png',
        title: 'Какие могут быть сложности при продаже квартиры?',
        notice: '6 мин. чтения',
        link: 'https://www.cian.ru/stati-kakie-mogut-byt-slozhnosti-pri-prodazhe-kvartiry-327324/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '73923d548975e06394a4f652bde52f45.png',
        title: 'Миссия выполнима: продажа квартиры по доверенности',
        notice: '8 мин. чтения',
        link: 'https://www.cian.ru/stati-missija-vypolnima-prodazha-kvartiry-po-doverennosti-299792/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '2b3d1dbd13dac240451f0abd47e2b75d.png',
        title: 'Когда и как выписываться из квартиры при ее продаже',
        notice: '8 мин. чтения',
        link: 'https://www.cian.ru/stati-kogda-i-kak-vypisyvatsja-iz-kvartiry-pri-ee-prodazhe-327310/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'ec49cc427e3a7d3faaf576481d8d7486.png',
        title: 'Кадастровая стоимость недвижимости: зачем она нужна, как ее узнать и оспорить',
        notice: '8 мин. чтения',
        link: 'https://www.cian.ru/stati-otsenka-zachem-nuzhna-kadastrovaja-stoimost-zhilja-301143/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '179bcda7282419219fb0446af5cc85f5.png',
        title: 'Налог на недвижимость: кто, сколько и когда должен платить',
        notice: '16 мин. чтения',
        link: 'https://www.cian.ru/stati-nalog-na-nedvizhimost-kto-skolko-i-kogda-dolzhen-platit-327622/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '933a2875d2c9680777d300faeb66cde6.png',
        title: 'Как продать квартиру и не платить налог?',
        notice: '14 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-prodat-kvartiru-i-ne-platit-nalog-315517/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '0d0ba7f12d16e13ca5bf964e158e59b3.png',
        title: 'Как подать налоговую декларацию при продаже жилья: ответы на вопросы и пример',
        notice: '16 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-podat-nalogovuju-deklaratsiju-pri-prodazhe-zhilja-otvety-na-voprosy-i-primer-331994/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
];
